import { createContext } from 'react';

/** Access whether this is debug mode or not. */
const DebugModeContext = createContext<boolean>(false);
export default DebugModeContext;
